import { IssueFormRecordType } from "../components/issue-form";

export function createIssueRouteForRecord({
  type,
  recordId,
  label,
}: {
  type: IssueFormRecordType;
  recordId: string;
  label: string;
}): string {
  const params = new URLSearchParams({
    recordType: type,
    recordId,
    recordLabel: label,
  });

  return `/admin/issue/list/create?${params.toString()}`;
}
